// 
var QualifyRedirector = xClass("QualifyRedirector", BaseRedirector)
QualifyRedirector.prototype.getName = function () {
    var self = this
    return "qualify"
}
QualifyRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
QualifyRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log("Qualify QualifyRedirector um.settings",um.settings)
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("点击自己的链接无效哦，去分享给好友吧~"));
        return true;
    }
    

    console.log("Qualify QualifyRedirector param",param)

    if (um.uid && param.inviteCode && param.shareId) {
        let http = QualifyingShareClickHttp.new();
        http.addEventListener(Events.kComplete, (evt) => {
            cc.log("Qualify shareClick evt ",evt)
            // 加入成功 主界面直接强弹加入   其他场景（GameScene PreloadScene）弹出Toast提示
            var scene = cc.Director.getInstance().getRunningScene();
            cc.log("Qualify shareClick scene.name ",scene.name)
            if (scene && scene.name == "HomeScene"){
                let mgr = QualifyGameManager.getInstance()
                let status = evt.data.status
                cc.log("Qualify shareClick status",status)
                Toast.make(getText(`qualifying_join_${status}`));
                mgr.loadConfig().then(()=>{
                    mgr.updateInfo(evt.data)
                    mgr.updateIcon()
                    mgr.showMainPanel()
                    mgr.dcEnterGroup("invite")
                }).catch(()=>{

                    })
            }else {
                Toast.make(getText("晋级赛加入小组成功"));
            }
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            // 加入失败
            // Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"));
            if (evt.data){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}
module.exports = QualifyRedirector
